import { render, staticRenderFns } from "./ServicioScreen.vue?vue&type=template&id=442a0a80&scoped=true&"
import script from "./ServicioScreen.vue?vue&type=script&lang=js&"
export * from "./ServicioScreen.vue?vue&type=script&lang=js&"
import style0 from "./ServicioScreen.vue?vue&type=style&index=0&id=442a0a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a0a80",
  null
  
)

export default component.exports